import React from 'react';
import classNames from 'classnames';
import { t } from 'i18next';
import styles from './HeadlineWithButtons.module.scss';
import Button, { ExtendedButtonProps } from '../Button/Button';
import { OptionItemProps } from '../OptionItem/OptionItem';
import MenuButton from '../Button/MenuButton';

export interface HeadlineWithButtonsProps {
  headline: string;
  subline?: string;
  buttons?: (ExtendedButtonProps & { menuItems?: OptionItemProps[] })[];
  customSpacing?: string;
  children?: React.ReactNode;
}

const HeadlineWithButtons: React.FC<HeadlineWithButtonsProps> = ({
  headline,
  subline,
  buttons = [],
  customSpacing,
  children,
}) => {
  return (
    <div className={classNames(styles.root, customSpacing || 'mb-24')}>
      <div className={classNames(styles.head)}>
        <h1 className="typo-title-36">{headline}</h1>
        {buttons.length > 0 && (
          <div className="flex items-center gap-8">
            {buttons.map(b => {
              if (b.title === t('general.create')) {
                return (
                  <MenuButton
                    key={b.title}
                    title={b.title}
                    tone={b.tone}
                    menuItems={b.menuItems ?? []}
                    className={b.className}
                    disabled={b.disabled}
                  />
                );
              }
              return <Button key={b.title} {...b} />;
            })}
          </div>
        )}
      </div>
      {subline && <p className="typo-text-14 text-faded text-left">{subline}</p>}
      {children}
    </div>
  );
};

export default HeadlineWithButtons;
